export const getUserInitials = (firstName = 'N', lastName = 'A') => {
  return `${firstName[0]}${lastName[0]}`.toUpperCase()
}

export const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+@[A-Za-z0-9.-]+[A-Za-z0-9]$/)
